
import React from "react";
import { Check } from "lucide-react";

const AttitudeRatingInfo = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold flex items-center gap-2">
          <span className="text-red-500">◆</span> มิติที่ 3: ทัศนคติ (Attitude)
        </h2>
        <p className="text-gray-700 mt-1">วัดจาก: ความตั้งใจ / ความกระตือรือร้น / ความร่วมมือในคลาส</p>
      </div>

      <div className="space-y-4">
        <div>
          <h3 className="font-semibold">5 คะแนน = ระดับเชี่ยวชาญ (Mastery)</h3>
          <p className="text-sm mb-2">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>สนใจเรียน กระตือรือร้น ถาม-ตอบ <span className="font-bold">เชิงลึก</span> กับครูเอง</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>มีสมาธิต่อเนื่อง ไม่เสียสมาธิแม้ไม่มีคนเตือน</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>แสดงออกว่ามีแรงบันดาลใจในการเรียน</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold">4 คะแนน = ระดับเข้าใจดี (Proficient)</h3>
          <p className="text-sm mb-2">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>สนใจเรียน <span className="font-bold">ส่วนใหญ่</span> ของคลาส มีการถาม-ตอบกับครู</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>มีสมาธิดี แต่บางครั้งยังต้องให้ครูเตือนไฟล์สบ้าง</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>มีพฤติกรรมให้ความร่วมมือกับครู</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold">3 คะแนน = ระดับปานกลาง (Developing)</h3>
          <p className="text-sm mb-2">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>ฟังและทำตามได้ดีในบางช่วง แต่มีบางจังหวะไม่โฟกัส</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>มีส่วนร่วมกับคลาสเป็นบางครั้ง แต่ไม่กล้าถามมากนัก</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>มีแรงจูงใจปานกลาง อาจต้องกระตุ้นเป็นระยะ</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold">2 คะแนน = ระดับต้องปรับปรุง (Emerging)</h3>
          <p className="text-sm mb-2">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>ตั้งใจเรียนเป็นบางช่วง <span className="font-bold">แต่เสียสมาธิบ่อย</span></span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>ไม่ค่อยมีส่วนร่วม หรือไม่ค่อยตอบคำถามในคลาส</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>ต้องกระตุ้นบ่อยเพื่อให้โฟกัสกับบทเรียน</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold">1 คะแนน = ระดับยังไม่เข้าใจ (Beginning)</h3>
          <p className="text-sm mb-2">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>ไม่ค่อยสนใจเรียน / เนื้อหาไม่ชัดเจน</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>ไม่ตอบสนองต่อคำถาม หรือแสดงออกว่าไม่อยากเรียน</span>
            </li>
            <li className="flex items-start gap-2">
              <Check className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <span>ไม่มีแรงจูงใจ ต้องกระตุ้นตลอด</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AttitudeRatingInfo;
